import React from 'react';
import withIcon from '../utilities/withIcon';

const IconArrowDown = () => {
  return (
    <g>
      <path d="M8.001 1a.75.75 0 0 1 .744.648l.005 10.791 3.964-3.968a.749.749 0 0 1 .976-.073l.084.073c.266.266.29.683.073.977l-.073.084-5.243 5.251a.749.749 0 0 1-.976.073l-.084-.073L2.225 9.53A.752.752 0 0 1 3.2 8.394l.084.073 3.964 3.968L7.25 1.75A.75.75 0 0 1 8.001 1z" />
    </g>
  );
};

export default withIcon(IconArrowDown);
